<template>
  <div class="row">
    <div class="col-sm-12">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Produkt</th>
            <th>Kategorie</th>
            <th>Einheit</th>
            <th>Artikelnummer</th>
            <th>Verkaufspreis</th>
            <th style="width: 110px;">Einkaufspreis (netto)</th>
            <th>Günstigster Einkaufspreis (netto)</th>
            <th>Auf Lager</th>
            <th>Bestellt</th>
            <th class="text-center">Lager</th>
            <th class="text-center">Lieferanten</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products" :key="product.id"
            is="SupplierProductRow"
            :product="product"
            @openSuppliers="openSuppliers"
            @deleteProduct="$emit('deleteProduct', $event)"
            @openWarehouses="openWarehouses"
          />
        </tbody>
      </table>
    </div>
    <product-suppliers-dialog
      :show="showSuppliers"
      :product="selectedProduct"
      @deleteProductSupplier="deleteProductSupplier"
      @close="showSuppliers = false"
    />
    <product-warehouses-dialog
      :show="showWarehouses"
      :product-warehouses="productWarehouses"
      @close="showWarehouses = false"
    />
  </div>
</template>

<script>
import ProductSuppliersDialog from 'src/pages/Products/product-suppliers-dialog'
import ProductWarehousesDialog from 'src/pages/Products/product-warehouses-dialog'
import SupplierProductRow from './supplier-product-row'

export default {
  props: ['products'],
  components: { ProductSuppliersDialog, ProductWarehousesDialog, SupplierProductRow },
  data () {
    return {
      productSuppliers: [],
      productWarehouses: [],
      showSuppliers: false,
      showWarehouses: false,
      selectedProduct: null
    }
  },
  methods: {
    openSuppliers ({ productSuppliers, product }) {
      this.selectedProduct = product
      this.showSuppliers = true
    },
    openWarehouses (product) {
      this.$http.get(`/products/${product.id}/warehouses`).then(({ data }) => {
        this.productWarehouses = data
        this.showWarehouses = true
      })
    },
    async deleteProductSupplier (supplier) {
      if (confirm('Zuweisung zum Lieferanten wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/product_supplier/${supplier.id}`).then(({ data }) => {
          const index = this.selectedProduct.suppliers.findIndex(({ id }) => id === data.id)
          this.selectedProduct.suppliers.splice(index, 1)
        })
      }
    }
  }
}
</script>

<style>
</style>
